export default __webpack_public_path__ + "static/media/logo__project__goblin.3705214a.png";